import React, { useEffect, useState, useRef, Fragment } from 'react'

import { Card, Badge, Popconfirm, Tooltip, Tag, Avatar } from 'antd'
import moment from 'moment'
import { IconSvg } from '../../../../componentIsoMophic/ScrumBoard/IconSvg/IconSvg'
import { HrBar, CardFooter, CardBody } from '../Task.style'
import ClockIcon from '../../../assets/images/icon/17.svg'
import plus from '../../../assets/images/icon/24.svg'
import RemoveIcon from '../../../assets/images/icon/02-icon.svg'
import CommentsIcon from '../../../assets/images/icon/09-icon.svg'
import AttachmentIcon from '../../../assets/images/icon/01-icon.svg'
import scrumBoardActions from '../../../../redux/scrumBoard/actions'
import { connect } from 'react-redux'
import defaultImg from '../../../../resource/image/defaultAvatar.png'

import {
    CardAttachment,
    CardComment,
    FooterLeft,
    CardTitle,
    CardIcon,
    CardContent,
} from './TaskCard.style'
import Task from '../Task'

const TaskCard = ({
    task,
    showDrawer,
    onDelete,
    getListCommentReport,
    totalComment,
    currentListUserData,
}) => {
    useEffect(() => {
        if (task.type === 'report') {
            // console.log('get comment report', task)
            // getListCommentReport(task.id)
        }
    }, [getListCommentReport])
    const currentUserInfo = currentListUserData.find(data => {
        return task.owner_id === data.uid
    })
    const findTotalReportComment = () => {
        const total = totalComment.find(cmt => {
            return cmt.rid === task.id
        })
        console.log('total comment', total)
        if (total) {
            return total.total
        } else {
            return 0
        }
    }
    const CardHeader = (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <CardIcon src={ClockIcon} alt="Clock Icon" mr={10} />
            {moment(task.created_at * 1000).format('DD/MM/YYYY')}
        </div>
    )
    const getcardTitle = () => {
        if (task.type === 'event') {
            return 'Sự kiện liên quan'
        }
        if (task.type === 'object') {
            return 'Đối tượng liên quan'
        }
        if (task.type === 'require') {
            return 'Thông tin nhiệm vụ'
        }
    }
    const getRandomInt = max => {
        return Math.floor(Math.random() * Math.floor(max))
    }
    const getColorTag = () => {
        const color = [
            'magenta',
            'red',
            'volcano',
            'orange',
            'gold',
            'lime',
            'green',
            'cyan',
            'blue',
            'geekblue',
            'purple',
        ]
        const index = getRandomInt(color.length)

        return color[index]
    }
    return (
        <Card
            style={{
                width: '100%',
                borderRadius: '10px',
                backgroundColor: '#ffffff',
                cursor: 'pointer',
            }}
            onClick={showDrawer}
            bodyStyle={{ padding: 0 }}
            headStyle={{ borderBottom: 'none', fontSize: 13, color: '#788195' }}
            bordered={false}
            title={CardHeader}
            // extra={
            //     <Popconfirm
            //         title="Bạn có chắc chăn muốn xoá đi thẻ này ?"
            //         okText="Xoá"
            //         cancelText="Không"
            //         onConfirm={onDelete}
            //     >
            //         <IconSvg src={RemoveIcon} mr={'0'} width={25} height={25} />
            //     </Popconfirm>
            // }
        >
            <CardBody>
                <CardTitle>{getcardTitle()}</CardTitle>
                <CardContent>{task.title}</CardContent>
                {task.labels.map(label => (
                    <Tag color={getColorTag()}>{label}</Tag>
                ))}
            </CardBody>
            <HrBar />
            <CardFooter>
                <FooterLeft>
                    {task.type === 'report' && (
                        <CardComment>
                            <CardIcon src={CommentsIcon} mr={5} />
                            {findTotalReportComment()}
                        </CardComment>
                    )}
                </FooterLeft>
                {
                    <Tooltip
                        title={currentUserInfo.user_name}
                        placement="bottom"
                        key={Tooltip}
                    >
                        <Avatar
                            src={
                                currentUserInfo.avatar !== ''
                                    ? currentUserInfo.avatar
                                    : defaultImg
                            }
                        />
                    </Tooltip>
                }
            </CardFooter>
        </Card>
    )
}
export default connect(
    (state, ownProps) => {
        return {
            totalComment: state.scrumBoard.totalComment,
            currentListUserData: state.scrumBoard.currentListUserData,
        }
    },
    {
        ...scrumBoardActions,
    }
)(TaskCard)
